export const TAGGING_FIELDS = {
  CARD_PAYMENT: 'Card Payment',
  F2F_PAYMENT: 'Face to Face Payment',
  INDUSTRY: 'Industry',
  ANNUAL_TURNOVER: 'Annual turn over',
  AVERAGE_CARD_PAYMENT: 'Average Card Payment',
  CTO: 'CTO',
  MCC_TOOLTIP: 'MCC tooltip',
  SECTOR: 'Sector',
  FACE_TO_FACE_PAYMENTS_TICK: 'Face to Face Payments: Tick',
  FACE_TO_FACE_PAYMENTS_UNTICK: 'Face to Face Payments: Untick',
  OVER_THE_PHONE_PAYMENTS_TICK: 'Over the Phone Payments: Tick',
  OVER_THE_PHONE_PAYMENTS_UNTICK: 'Over the Phone Payments: Untick',
  ONLINE_PAYMENTS_TICK: 'Online Payments: Tick',
  ONLINE_PAYMENTS_UNTICK: 'ONLINE Payments: Untick',
  FACE_TO_FACE_PROPORTION: 'Face to Face Proportion',
  PCI_DSS_TOOLTIP: 'PCI DSS tooltip',
  PCI_DSS_COMPLIANCE: 'PCI DSS Compliance',
  MYSELF: 'Myself',
  HELP: 'Help',
  PCI_DSS_COMPLIANCE_MYSELF: 'PCI DSS Compliance: Myself',
  PCI_DSS_COMPLIANCE_HELP: 'PCI DSS Compliance: Help',
  Cancel: 'Cancel',
  NEXT: 'Next',
  DOWNLOAD_QUOTE: 'Download Quote',
  EXISTING_PHONE_NUMBER: 'Existing Phone Number',
  NEW_CARDENET_PHONE_NUMBER: 'New to Cardnet Phone Number',
  APPLY_NOW: 'Apply Now',
  CALL_ME_BACK: 'Call Me Back',
  RETURN_TO_CARDNET: 'Return to Cardnet',

  F_2_F_CARD_PAYMENT: 'Face-to-Face Card Payment',
  BUSINESS_TYPE: 'Business Type',

  // Email
  EMAIL: 'Email Address',
  VALIDATION_ERROR: 'Validation Error',
  ADD_PHONE_NUMBER: 'Enter Phone Number',

  // High CTO
  OVERLAY: 'Overlay',
  HIGH_CTO: 'High CTO',
  HIGH_CTO_CLOSE: 'High CTO Close',
  HIGH_CTO_OK: 'High CTO Ok',
  DECLINE_RETURN_TO_CARDNET: 'Return to Cardnet',
};

export const LINK_VALUE = {
  highctook: 'button/highctook',
  highctoclose: 'button/highctoclose',
  mcctooltip: 'button/mcctooltip',
  facetofacepaymentstick: 'button/facetofacepaymentstick',
  facetofacepaymentsuntick: 'button/facetofacepaymentsuntick',
  overthephonepaymentstick: 'button/overthephonepaymentstick',
  overthephonepaymentsuntick: 'button/overthephonepaymentsuntick',
  onlinepaymentstick: 'button/onlinepaymentstick',
  onlinepaymentsuntick: 'button/onlinepaymentsuntick',
  pcidsstooltip: 'button/pcidsstooltip',
  pcidsscompliancemyself: 'button/pcidsscompliancemyself',
  pcidsscompliancehelp: 'button/pcidsscompliancehelp',
  next: 'button/next',
  cancel: 'button/cancel',
  yescancel: 'button/yescancel',
  nocarryon: 'button/nocarryon',
  downloadquote: 'button/downloadquote',
  applynow: 'button/applynow',
  returntocardnet: 'button/returntocardnet',
};

export const JOURNEY_EVENT = {
  BUTTON_CLICK: 'Button Click',
  EXTERNAL_CLICK: 'External Click',
  INTERNAL_CLICK: 'Internal Click',
  FIELD_CLICK: 'Field Click',
  FORM_ENTRY: 'Form Entry',
  FIELD_UPDATE: 'Field Update',
  PAGE_SUBMIT: 'Page Submit',
  OVERLAY: 'Overlay',
  GLOSSARY_CLICK: 'Glossary Click',
  SUPPORTING_MATERIAL: 'Supporting Material',
};
